// Adept Client Services - Service
// Can't start with "Adept" because it is less than "app".
(function () {
    'use strict';

    angular
        .module('app')
        .factory('SchemaService', SchemaService);

    SchemaService.$inject = ['$http', '$q', 'clientService'];

    function SchemaService($http, $q, clientService) {

        var service = {
            schemas: null,
            GetAllSchemaModels: GetAllSchemaModels
        };
        return service;

        function GetAllSchemaModels(suppressError) {
            var deferred = $q.defer();
            if (service.schemas != null) {
                deferred.resolve(service.schemas);
            }
            else {
                var url = '../Synergis.WebApi/api/Schema/GetAllSchemaModels';
                var request = $http.get(url);
                request.then(function (response) {
                    service.schemas = response.data;
                    deferred.resolve(service.schemas);
                }, function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }
    }
})();
